import gql from 'graphql-tag';
import communityMemberInfoFragment from '../communityMember/communityMemberInfo';

export default gql`
  fragment communityMembers on Community {
    members(after: $after, filter: $filter, first: $first)
      @connection(key: "communityMembers", filters: ["filter"]) {
      pageInfo {
        hasNextPage
        hasPreviousPage
      }
      edges {
        cursor
        node {
          ...communityMemberInfo
        }
      }
    }
  }
  ${communityMemberInfoFragment}
`;
